import { useDataValue, useDataSubmit, useDataChange } from 'Simple/Data'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'

export function useOnClick(props) {
  let selected_id = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'id',
  })
  let type = useDataValue({
    viewPath: props.viewPath,
    context: 'selected',
    path: 'type',
  })

  let persons = useDataValue({
    viewPath: props.viewPath,
    context: 'similar_persons',
  })

  let submit = useDataSubmit({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })

  let submitPerson = useDataSubmit({
    context: 'similar_persons',
    viewPath: props.viewPath,
  })

  let change = useDataChange({
    context: 'appointment_overlay',
    viewPath: props.viewPath,
  })

  let setFlowTo = useSetFlowTo(props.viewPath)

  return async function onClick(value) {
    let person = persons.find(p => p.id === selected_id)
    if (type === 'lead') {
      submit({
        type: 'schedule',
        lead_id: person.id,
      })
    } else {
      if (!person?.patient) {
        submitPerson({
          type: 'add_patient_to_person',
          person_vaxiom_id: person.vaxiom_id,
        })
        return
      }
      change(next => {
        next.patient_id = person.patient._id
        next.patient_option = 'existing'
        next.skip_appointment_reset = true
      })
      setFlowTo(normalizePath(props.viewPath, '../../../../No'))
    }
  }
}
